<!--
 * @Author: your name
 * @Date: 2020-08-25 08:44:18
 * @LastEditTime: 2020-08-26 15:05:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \jiachi\src\components\about\history.vue
-->
<template>
<div class="history">
    <h1>发展大事记</h1>
    <p>Development events</p>
    <div>
        <svgs id="svg" />
    </div>
</div>
</template>

<script>
import svgs from '../svgs'

export default {
    components: {
        svgs
    }
};
</script>

<style lang="less" scoped>
.history {
    width: 100%;
    height: 840px;
    background: url("../../assets/img/history.png") no-repeat;
    background-size: contain;
    position: relative;
    text-align: center;
    // padding-top: 90px;

    &>h1 {
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        position: absolute;
        top: 90px;
        left: 0;
        display: inline;
        left: 50%;
        transform: translateX(-50%);
    }

    &>p {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        position: absolute;
        top: 140px;
        left: 0;
        color: rgba(255, 255, 255, 1);
        display: inline;
        left: 50%;
        transform: translateX(-50%);
    }
}
</style>
